import { emailValidator } from '#validation/common/validators';
export const userEmailValidator = emailValidator({
    requiredError: 'user.email.required',
    formatError: 'user.email.format',
});
